import React, { useEffect, useState } from "react";
// import RoomBookingTable from "./Components/RoomBookingTable";
// import { useDispatch} from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import RestaurantCategoryTable from "./Components/RestaurantCateogoryTable";
import AddRestaurantCategory from "./Components/AddRestaurantCategory";
import { hasAddAccess } from "../../../../Common/CheckAccess";

const RestaurantCategoryList = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { reservation_id } = location.state || {};
  const [selectedCategory, setSelectedCategory] = useState();

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Category List</h3>
              <div className="col-auto d-flex w-sm-100">
                {hasAddAccess(permissions, "restaurant") && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#add-category"
                    aria-controls="add-category"
                    onClick={() => setSelectedCategory(null)}
                  >
                    Add Category
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <RestaurantCategoryTable
                  setSelectedCategory={setSelectedCategory}
                  // data ={roomReservation.data}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddRestaurantCategory
        setSelectedCategory={setSelectedCategory}
        selectedCategory={selectedCategory}
      />
    </>
  );
};
export default RestaurantCategoryList;
